var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArchive = function SvgArchive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.503 6.667h-.667V2.669A.67.67 0 0 1 2.497 2h12.01a.66.66 0 0 1 .662.669v3.998h-.666v6.667a.662.662 0 0 1-.662.666H3.165a.665.665 0 0 1-.662-.666V6.667Zm10.666 0H3.836v6h9.333v-6Zm-10-3.334v2h10.667v-2H3.169ZM6.503 8h4v1.333h-4V8Z"
  })));
};
export default SvgArchive;